import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTrackOrderCardStyles = isLastItem => {
  return StyleSheet.create({
    listContent: {
      marginBottom: isLastItem ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_32
    },
    buttonContainer: {
      marginTop: tokens.spacing.SPACING_16
    }
  });
};